import React from "react";
import { Link } from "gatsby";
import { useIntl } from "gatsby-plugin-intl";
  
const Navigation = ({ navClass }) => {
  const intl = useIntl();
  const locale = intl.locale !== "en" ? `/${intl.locale}` : "";
    return(
    <>
          <Link className={navClass}  
            to={`${locale}/`}>
            {intl.formatMessage({ id: "Home Page" })}
          </Link>

          <Link className={navClass} 
            to={`${locale}/about-us/`}>
            {intl.formatMessage({ id: "About us" })}
          </Link>
      
          <Link className={navClass} 
            to={`${locale}/services`}>
            {intl.formatMessage({ id: "Services" })}
          </Link>
  
          <Link className={navClass} 
            to={`${locale}/staff`}>
            {intl.formatMessage({ id: "Staff" })}
          </Link>
    
          <Link className={navClass} 
            to={`${locale}/blog`}>
            {intl.formatMessage({ id: "Blog" })}
          </Link>
      
          <Link className={navClass} 
            to={`${locale}/contact`}>
            {intl.formatMessage({ id: "Contact" })}
          </Link>
      </> 
    )
  }
  Navigation.defaultProps = {
    navClass: `site-nav-item`,
  }
export default Navigation
